/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { EmailDetailService } from '../services/email-detail.service';
import { OpsService } from '../services/ops.service';
import { AuthService } from '../services/auth.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { SessionService } from '../services/session2.service';
import { ConfirmDialogComponent } from '../global/confirm-dialog/confirm-dialog.component';
import { ErrorService } from '../services/error.service';
import { GlobalMessageService } from '../services/global-message.service';
import { DriftService } from '../services/drift.service';

import { Constants, EmailType } from '../global/constants';

//import { Animations } from '../global/animations';

@Component({
  selector: 'app-email-detail',
  templateUrl: './email-detail.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class EmailDetailComponentOLD implements OnInit {

  loadingPage:boolean = true;
  id: string;
  ed: any = {};
  senderContact: any = {};

  reportDialogRef: BsModalRef;
  typeDialogRef: BsModalRef;

  newType: string = '';

  highlight: boolean = true;

  notEnglish: boolean = false;
  showTranslate: boolean = false;
  translation: any = {};

  report: any = {
    incorrectType: false,
    missingName: false,
    missingOther: false,
    invalidName: false,
    badAssociation: false,
    comments: ''
  };

  currentUserId: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private domSanitizer: DomSanitizer,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private authService: AuthService,
              private errorService: ErrorService,
              private emailDetailService: EmailDetailService,
              private opsService: OpsService,
              private globalMessageService: GlobalMessageService,
              private modalService: BsModalService,
              private driftService: DriftService,
              private constants: Constants) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        if (!this.cacheService.get('session')) {
          this.sessionService.getSession(true).subscribe(
            (session: any) => {
              this.initView();
            }
          )
        }
        else {
          this.initView();
        }
      }
    )
  }

  getTypeClass(type:string) {
    let cssClass: string = 'category-3';
    let et: EmailType =
      this.constants.emailTypes.find((et) => {
        return et.display == type;
      });
    if (et) {
      cssClass = et.cssClass;
    }
    return cssClass;
  }

  reportProblem(dialog) {
    this.reportDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  sendReport() {
    this.reportDialogRef.hide();
    this.initReport();
    let report: any = {
      user_id: this.currentUserId,
      name: this.cacheService.get('session').name,
      account_id: this.cacheService.get('session').account_id,
      account: this.cacheService.get('session').account,
      ed_id: this.ed._id,
      ce_id: this.ed.ce_id,
      detail: this.report
    };

    this.emailDetailService.reportQA(report).subscribe(
      (result: any) => {
        this.globalMessageService.message('Email was reported. Thank you!');
        this.driftService.track('reported-email');
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'email-detail.component', 'reportProblem');
      }
    )
  }

  changeType(dialog) {
    this.typeDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  changeTypeConfirm() {
    this.typeDialogRef.hide();
    this.initReport();
    this.report.incorrectType = true;
    this.report.comments = `User changed type from ${this.ed.type} to ${this.newType}`;
    var model = {
      user_id: this.currentUserId,
      name: this.cacheService.get('session').name,
      account_id: this.cacheService.get('session').account_id,
      account: this.cacheService.get('session').account,
      ed_id: this.ed._id,
      ce_id: this.ed.ce_id,
      type: this.newType,
      detail: this.report
    };
    this.emailDetailService.changeType(this.id, model).subscribe(
      (result: any) => {
        this.initView();
        this.globalMessageService.message('Email type was changed');
        this.driftService.track('changed-emailtype');
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'email-detail.component', 'changeType');
      }
    )
  }

  deleteEmail() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to delete this email from your account',
        confirm: function() {
          let accountId = me.cacheService.get('session').account_id;
          me.emailDetailService.hide(me.ed._id, accountId).subscribe(
            (result: any) => {
              me.globalMessageService.message('Email was deleted');
              me.driftService.track('deleted-email');
              me.router.navigate(['inbox']);
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'email-detail.component', 'deleteEmail');
            }
          )
        }
      }
    }));
  }

  translate() {
    let truncated = this.ed.text;
    if (truncated.length > 400) {
      truncated = truncated.substring(0,399) + ' [...truncated]';
    }
    Observable.forkJoin(
      this.opsService.translate(this.ed.original_subject, 'en'),
      this.opsService.translate(truncated, 'en')
    ).subscribe(
      (result: any) => {
        this.translation = result;
        this.translation[1].translatedText = this.domSanitizer.bypassSecurityTrustHtml(this.translation[1].translatedText.replace(/\n/g, '<br />'));
        this.showTranslate = true;
      },
      error => {

      }
    )
  }

  private async initView() {
    this.currentUserId = await this.authService.getCurrentUserId();

    this.emailDetailService.getFullEmail(this.id).subscribe(
      (result: any) => {
        this.ed = result;
        this.ed.type = this.constants.emailTypes.find((ct) => {
          return ct.typeName == this.ed.type;
        }).display;

        if (this.ed.typeData.language != 'en') {
          this.notEnglish = true;
        }

        this.ed.contacts.forEach( (val, key) => {
            val.phone_number = val.phone_number ? val.phone_number.length > 0 ? val.phone_number : 'n/a' : 'n/a';
            if (val.sender) {
              this.senderContact = val;
            }
        });

        this.ed.parsed_dates.forEach((date) => {
            var utcDate = new Date(date.parsed);
            utcDate.setHours(utcDate.getHours() + 10);
            date.parsed = utcDate;
        });

        if (this.ed.body_start_index && this.ed.body_start_index >= 0) {
            this.ed.customer_email.text = this.ed.customer_email.text.substring(this.ed.body_start_index, this.ed.customer_email.text.length-1);
        }

        this.ed.clean = this.cleanHtml();
        this.ed.nohighlight = this.domSanitizer.bypassSecurityTrustHtml(this.ed.clean);
        this.ed.highlight = this.domSanitizer.bypassSecurityTrustHtml(this.addHighlights());
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'email-detail.component', 'initView');
      }
    )
  }

  private cleanHtml() {
    var markup = this.ed.customer_email.text
        .trim()
        .replace(/<mailto:(.{0,25}[@]).{0,40}>/g, ' ')  // these are hidden from parsing, hide them from the interface
        .replace(/[<>]+/g, ' ')                         // emails are sometimes hidden between these, dump them
        .replace(/\n/g, '<br />')                       // replace line feeds with break tags to preserve format for display
        .replace(/[\s]+/g, ' ');                        // replace all whitespace with a single space
    return markup + '<br/><br/>';
  }

  addHighlights() {
    var highlight = this.ed.clean;
    // sort people by length of title. This is to make sure that supersets of titles get highlighted
    // correctly. Otherwise "Assistant" gets highlighted twice when there's also "Assistant Director of Marketing"
    this.ed.contacts.sort(function (a, b) {
      if (a.title && a.title.length > b.title.length) {
          return -1;
      }
      else {
          return 1;
      }
    });

    this.ed.parsed_dates.forEach((d) => {
      var dRE = new RegExp(d.original.replace(/[+.()]/g, '\\$&'), 'gi');
      highlight = highlight.replace(dRE, '<span class="h-date">' + d.original + '</span>');
    });

    this.ed.contacts.forEach((p) => {
        if (!p.sender) {
          const safeEmail= p.email_address.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special characters for regex
          var eRE = new RegExp(safeEmail, 'gi');
          highlight = highlight.replace(eRE, '<span class="h-email">' + p.email_address + '</span>');

          if (p.name.indexOf('@') < 0) { // otherwise email alias is overwritten by name
            const safeName = p.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special characters for regex
            var nRE = new RegExp(safeName, 'gi');
            highlight = highlight.replace(nRE, '<span class="h-name">' + p.name + '</span>');
          }

          if (p.phone_number && p.phone_number.length > 0) {
            var pRE = new RegExp(p.phone_number.replace(/[+.()]/g, '\\$&'), 'gi');
            //var pRE = new RegExp(p.phone_number, 'gi');
            highlight = highlight.replace(pRE, '<span class="h-phone">' + p.phone_number + '</span>');
          }

          if (p.title && p.title.length > 0) {
            const safeTitle = (p.title).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            var tRE = new RegExp(safeTitle, 'gi');
            highlight = highlight.replace(tRE, '<span class="h-title">' + p.title + '</span>');
          }
        }
    });
    return highlight;
  }

  private initReport() {
    this.report = {
      incorrectType: false,
      missingName: false,
      missingOther: false,
      invalidName: false,
      badAssociation: false,
      comments: ''
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/email-detail/email-detail.component.ts